import { Environment } from '@cloud-and-service/portal-lib';

export const environment: Environment = {
  mode: 'production',
  appVersion: require('../../package.json').version,
  libVersion: require('../../node_modules/@cloud-and-service/portal-lib/package.json').version,
  environment: 'forsyning-dev',
  apiUrl: 'https://api-forsyningonline-development.azurewebsites.net/api',
  storageUrl: 'https://storageforsyningonline.blob.core.windows.net/',
  loginPageSettings: {
    allowNemId: true,
    allowQuickConsumption: true,
  },
  hideLocationChanger: false,
  licenceRequired: true,
};
